<div
    [ngClass]="{
        checkbox__with__background: densityCheckbox,
        checkbox__with__background__disabled: densityCheckbox && isDisabled,
        checkbox__with__background__readonly: densityCheckbox && readOnly,
        checkbox__with__background__invalid: densityCheckbox && inputStyle === 'invalid',
        checkbox__with__background__checked: densityCheckbox && value,
    }"
    class="sera-checkbox-container"
    (click)="handleClick($event, value)">
    <p-checkbox
        [ngClass]="inputStyle"
        [attr.sera-read-only]="readOnly ? '' : null"
        [name]="name"
        [(ngModel)]="value"
        [inputId]="inputId"
        [binary]="binary"
        [disabled]="isDisabled"
        [readonly]="readOnly"
        [required]="required"
        (onChange)="stateChanged.emit(value)"
        (click)="stopPropagation($event)">
    </p-checkbox>
    <label
        *ngIf="label"
        [for]="inputId"
        >{{ label }}</label
    >
</div>
